import React from 'react';
import { styleComponent } from '%app/js/common/components/styles';
import { css } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

const RouterLinkStyled = styleComponent(RouterLink, css`
    text-decoration: none;
    color: inherit;
`);

function Link(props, ref) {
    const { children, ...rest } = props;

    return (
        <RouterLinkStyled {...rest} ref={ref}>{children}</RouterLinkStyled>
    );
}

export default React.forwardRef(Link);
